import { useState } from 'react';
import { categories, timelineEvents } from '@/mocks/gua';

const stageColor: Record<string, string> = {
  起因: 'bg-primary-100 text-primary-800',
  发酵: 'bg-accent-100 text-accent-800',
  高潮: 'bg-primary-200 text-primary-900',
  多方下场: 'bg-accent-200 text-accent-900',
  回应: 'bg-secondary-100 text-secondary-800',
  结局: 'bg-background-200 text-foreground-800',
  关键节点: 'bg-primary-200 text-primary-900',
  旧闻重现: 'bg-accent-200 text-accent-900',
  处理: 'bg-secondary-200 text-secondary-900',
  收尾: 'bg-background-200 text-foreground-800',
  进展: 'bg-secondary-200 text-secondary-900',
  降温: 'bg-background-200 text-foreground-800',
};

export default function TimelineSection() {
  const [active, setActive] = useState('all');
  const list = active === 'all' ? timelineEvents : timelineEvents.filter((e) => e.category === active);

  return (
    <section className="w-full bg-background-100/60 py-12 md:py-16">
      <div className="container-x">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div className="flex flex-col gap-1.5">
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">事件时间线专区</span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">起因到结局，一次讲透</h2>
            <p className="mt-1 max-w-2xl text-sm text-foreground-700">
              每个热点事件按发生顺序拆成起承转合，点开一个栏目，即可按需切换查看。
            </p>
          </div>
        </div>

        <div id="timeline" className="mt-8 flex flex-wrap items-center gap-2 scroll-mt-24">
          {categories.map((c) => (
            <button
              key={c.key}
              type="button"
              onClick={() => setActive(c.key)}
              className={`inline-flex whitespace-nowrap items-center gap-1.5 rounded-full px-4 py-1.5 text-sm transition-colors ${
                active === c.key
                  ? 'bg-foreground-950 text-background-50'
                  : 'bg-background-50 text-foreground-700 ring-1 ring-background-200 hover:bg-background-200/60'
              }`}
            >
              <i className={c.icon} aria-hidden="true"></i>
              {c.name}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-2">
          {list.map((ev) => (
            <article
              key={ev.id}
              className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <div className="flex flex-wrap items-center gap-2 text-xs text-secondary-600">
                <span className="rounded-full bg-accent-100 px-2.5 py-0.5 font-medium text-accent-900">
                  {categories.find((c) => c.key === ev.category)?.name}
                </span>
                <span>
                  <i className="ri-time-line mr-1" aria-hidden="true"></i>
                  {ev.period}
                </span>
              </div>

              <h3 className="mt-3 font-heading text-lg md:text-xl font-bold text-foreground-950">{ev.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{ev.intro}</p>

              <div className="mt-4 flex flex-wrap gap-1.5">
                {ev.tags.map((t) => (
                  <span key={t} className="rounded-full px-2.5 py-0.5 text-xs font-medium">
                    {t}
                  </span>
                ))}
              </div>

              <ol className="relative mt-5 border-l-2 border-background-200 pl-5 space-y-4">
                {ev.stages.map((s) => (
                  <li key={s.time} className="relative">
                    <span className="absolute -left-[27px] top-1 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-primary-500 ring-4 ring-background-50"></span>
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="font-label text-xs font-semibold text-foreground-950">{s.time}</span>
                      <span
                        className={`inline-flex rounded-full px-2 py-0.5 text-[11px] font-medium ${
                          stageColor[s.label] || 'bg-secondary-100 text-secondary-800'
                        }`}
                      >
                        {s.label}
                      </span>
                    </div>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-700">{s.text}</p>
                  </li>
                ))}
              </ol>

              <a
                href="#review"
                className="mt-5 inline-flex whitespace-nowrap items-center gap-1 text-sm font-medium text-primary-700 transition-colors hover:text-primary-600"
              >
                查看完整复盘
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}